module.exports = __webpack_public_path__ + "img/vehicle-banner.a9ca856e.jpg";